export default __webpack_public_path__ + "static/media/cover-6.70b8279d.webp";